document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".v2-top-slider")) {
    {
      // v2-top-slider
      const splide_top_main = new Splide(".js-splide-top-main", {
        autoplay: false,
        type: "loop",
        pagination: true,
        arrows: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        interval: 1000,
        speed: 300,
        perPage: 1,
        fixedWidth: "1080px",
        padding: "calc((100% - 1080px) / 2)",
        lazyLoad: "nearby",
        preloadPages: 1,
        flickPower: 300,
        gap: 10,
        breakpoints: {
          1080: {
            fixedWidth: "calc((350 / 390) * 100vw)",
            padding: "calc((20 / 390) * 100vw)",
            gap: 8,
            arrows: false,
          },
        },
      });
      splide_top_main.mount();

      // Loop modeの初期位置ずれを修正（トップページindex.jsと同等の対策）
      var fixPosition = function () {
        splide_top_main.refresh();
      };
      requestAnimationFrame(function () {
        requestAnimationFrame(fixPosition);
      });
      setTimeout(fixPosition, 150);
    }
  }
  // Check if an element with the class .js-splide-top-info exists
  if (document.querySelector(".js-splide-top-info")) {
    // If it exists, initialize the Splide slider
    // info slider
    const splide_top_info = new Splide(".js-splide-top-info", {
      autoplay: true,
      type: "slide",
      pagination: false,
      arrows: true,
      interval: 1000,
      speed: 4000,
      // fixedWidth: 530,
      // gap: 20,
      perPage: 1,
      drag: true,
      start: 0,
      breakpoints: {
        1080: {
          fixedWidth: 288,
          gap: 10,
          arrows: false,
        },
      },
    });
    splide_top_info.mount();
  }

  if (document.querySelector(".js-splide-top-new-product")) {
    {
      //new products slider
      const splide_top_new_product = new Splide(".js-splide-top-new-product", {
        autoplay: false,
        type: "slide",
        pagination: false,
        arrows: true,
        interval: 1000,
        speed: 300,
        fixedWidth: 255,
        gap: 20,
        perPage: 1,
        drag: true,
        start: 0,
        breakpoints: {
          1080: {
            fixedWidth: 110,
            gap: 10,
            arrows: false,
          },
        },
      });
      splide_top_new_product.mount();
    }
  }

  const futureSplides = document.querySelectorAll(".js-future-list-splide");
  futureSplides.forEach((splideRoot) => {
    const items = splideRoot.querySelectorAll(".item");
    if (items.length <= 4) {
      return;
    }

    const mediaQuery = window.matchMedia("(min-width: 1080px)");
    let instance = null;
    const container = splideRoot.closest(".future-list");

    const enable = () => {
      if (instance || !mediaQuery.matches) {
        return;
      }
      splideRoot.classList.add("splide");
      if (container) {
        container.classList.add("is-splide-enabled");
      }
      instance = new Splide(splideRoot, {
        type: "slide",
        perPage: 4,
        perMove: 1,
        gap: 20,
        pagination: false,
        arrows: true,
        drag: true,
        speed: 300,
      });
      instance.mount();
    };

    const disable = () => {
      if (!instance) {
        return;
      }
      instance.destroy(true);
      instance = null;
      splideRoot.classList.remove("splide");
      if (container) {
        container.classList.remove("is-splide-enabled");
      }
    };

    const handleResize = () => {
      if (mediaQuery.matches) {
        enable();
      } else {
        disable();
      }
    };

    handleResize();
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleResize);
    } else {
      mediaQuery.addListener(handleResize);
    }
  });
});
